//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class BranchService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[Branch.Delete]
	async delete(branchId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:branchId
		}
	
		return await _server.delete('/hub/branch/delete', {'params':params})
	};

	//GeneratorFlag:[Branch.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/branch/detail', {'params':params});
	};

	//GeneratorFlag:[Branch.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/branch/list', {'params':params});
	};

	//GeneratorFlag:[Branch.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/branch/create', params || { });
	};

	//GeneratorFlag:[Branch.PositionList]
	async positionList(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/hub/branch/position-list', {'params':params});
	};

	//GeneratorFlag:[Branch.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/branch/update', params || { });
	};

	//GeneratorFlag:[Branch.Move]
	async move(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/hub/branch/move', params || { });
	};

//GeneratorFlag:[NewAction]
}